if (!customElements.get('up-perso-loader')) {
  class upPersoLoader extends HTMLElement {
    constructor() {
      super();

      this.url = new URL(window.location.href);
      this.bookHandle = this.url.searchParams.get('book');

      //  UI
      this.errorSection = document.querySelector("section[id$='error_rte'] div");
      this.loadingSpinner = this.querySelector('.loading__spinner');
    }

    connectedCallback() {
      if (this.bookHandle) {
        const rootPathPrexif = window.routes.root_url !== '/' ? window.routes.root_url : '';
        this.bookUrl = `${window.shopUrl}${rootPathPrexif}/products/${this.bookHandle}`;
        this.renderForm();
      } else {
        console.error('[uP] Empty URL');
        this.loadingSpinner.classList.add('hidden');
        this.classList.remove('loading');
        if (this.errorSection) this.errorSection.style.display = 'block';
      }

      // TODO : fill entries if it's from cart
    }

    renderForm() {
      fetch(`${this.bookUrl}?section_id=up-book-personalization`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destinationForm = document.querySelector('#up-book-personalization  .js-contents');
          const sourceForm = html.querySelector('#up-book-personalization .js-contents');
          if (destinationForm && sourceForm) {
            destinationForm.innerHTML = sourceForm.innerHTML;
          }
          if (!sourceForm.querySelector('up-perso-module')) {
            console.log('[uP] URL is not valid');
            if (this.errorSection) this.errorSection.style.display = 'block';
          }
        })
        .then(() => {
          this.updateLinks();
        })
        .catch((e) => {
          console.error(e);
          if (this.errorSection) this.errorSection.style.display = 'block';
        })
        .finally(() => {
          this.classList.remove('loading');
          this.loadingSpinner.classList.add('hidden');
        });
    }

    updateLinks() {
      const closeIcon = document.querySelector('.up-bperso__header-close');
      if (closeIcon) closeIcon.href = this.bookUrl;
      const logoLink = document.querySelector('.up-bperso__header .header__heading-link');
      if (logoLink) logoLink.href = this.bookUrl;
    }
  }
  customElements.define('up-perso-loader', upPersoLoader);
}

function upFormatMoney(cents, format = '') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.upSettings.moneyFormatDefault || window.upSettings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  let value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

if (!customElements.get('up-perso-steps')) {
  class upPersoSteps extends HTMLElement {
    constructor() {
      super();
      this.steps = this.querySelectorAll('.up-bperso-nav__item');
    }

    connectedCallback() {
      // console.log('loading:up-perso-steps');
      this.steps.forEach((step, index) => {
        step.addEventListener('click', (event) => this.onStepClick.bind(this)(event, index));
      });
    }

    onStepClick(event, index) {
      this.dispatchEvent(
        new CustomEvent('up:change', {
          detail: {
            index: index,
          },
        })
      );
    }

    updateUI(stepIndex, isCompleted, isCurrent) {
      const step = this.steps[stepIndex];
      const stepButton = step.querySelector('button');

      if (isCompleted) {
        stepButton.removeAttribute('disabled');
        step.classList.add('up-bperso-nav__item--completed');
      } else {
        stepButton.setAttribute('disabled', '');
        step.classList.remove('up-bperso-nav__item--completed');
      }

      isCurrent
        ? step.classList.add('up-bperso-nav__item--current')
        : step.classList.remove('up-bperso-nav__item--current');
    }

    toggleStepVisibility(stepIndex, isVisible) {
      isVisible ? this.steps[stepIndex].classList.remove('hidden') : this.steps[stepIndex].classList.add('hidden');
    }

    fakeReIndex() {
      let newStepIndex = 1;
      this.steps.forEach((step) => {
        step.firstElementChild.textContent = newStepIndex;
        if (!step.classList.contains('hidden')) newStepIndex++;
      });
    }
  }
  customElements.define('up-perso-steps', upPersoSteps);
}

class upPersoFieldset extends HTMLElement {
  constructor() {
    super();

    this.isDisabled = this.hasAttribute('disabled') || false;

    this.inputs = Array.from(this.querySelectorAll('input, textarea'));
  }

  connectedCallback() {
    if (this.isDisabled) this.removeAttribute('disabled');
  }

  initStateFromParent(props) {
    Object.keys(props).forEach((key) => {
      const matchedInput = this.inputs.find((input) => input.name === key);
      if (matchedInput) matchedInput.value = props[key];
    });
  }

  verifyValidity() {
    let errorMessage = '';
    let validity = true;

    this.inputs.every((input) => {
      if (!input.disabled && !input.reportValidity()) {
        validity = false;
        errorMessage = window.upFormStrings.errorValidationGenericInput;
        input.classList.add('up-invalid-input');
        return false;
      } else {
        return true;
      }
    });

    return {
      validity: validity,
      errorMessage: errorMessage,
    };
  }

  getData() {
    const props = {};
    this.inputs.forEach((input) => {
      if (input.disabled) return;
      props[input.name] = input.value;

      // For the user label
      if (input.hasAttribute('aria-label')) {
        let rawValue = input.value;
        if (input.type == 'date') {
          const tempDate = new Date(input.value);
          if (tempDate instanceof Date && !isNaN(tempDate.valueOf()) && window.Intl?.DateTimeFormat) {
            rawValue = new Intl.DateTimeFormat(
              window.Shopify?.locale && window.Shopify?.country
                ? `${window.Shopify.locale}-${window.Shopify.country}`
                : navigator.language || navigator.userLanguage,
              {
                timeZone: 'UTC',
              }
            ).format(tempDate);
          }
        }

        props[input.getAttribute('aria-label')] = rawValue;
      }
    });
    return props;
  }
}
customElements.define('up-perso-fieldset', upPersoFieldset);

if (!customElements.get('up-perso-extra-writer')) {
  class upPersoExtraWriter extends upPersoFieldset {
    constructor() {
      super();

      // UI
      this.extraFieldsButton = this.querySelector('button[data-action="Add-Extra-Fields"]');
      this.removeExtraFieldsButton = this.querySelector('button[data-action="Remove-Extra-Fields"]');

      // Data
      this.isExtraFieldsActive = this.hasAttribute('extra-fields-active') || false;
      this.optionsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    connectedCallback() {
      super.connectedCallback();

      // Events for extrafields variant
      if (this.extraFieldsButton && this.removeExtraFieldsButton) {
        this.extraFieldsButton.addEventListener('click', () => this.toggleExtraFields.bind(this)(true));
        this.removeExtraFieldsButton.addEventListener('click', () => this.toggleExtraFields.bind(this)(false));
      }
    }

    toggleExtraFields(enable, dispatchEvent = true) {
      this.isExtraFieldsActive = enable;
      this.querySelectorAll('.up-field').forEach((field, index) => {
        if (enable) {
          this.extraFieldsButton.classList.add('hidden');
          this.removeExtraFieldsButton.classList.remove('hidden');
          field.classList.remove('hidden');
          this.inputs[index].removeAttribute('disabled');
        } else {
          this.extraFieldsButton.classList.remove('hidden');
          this.removeExtraFieldsButton.classList.add('hidden');
          field.classList.add('hidden');
          this.inputs[index].setAttribute('disabled', '');
        }
      });

      if (dispatchEvent) {
        this.dispatchEvent(
          new CustomEvent('up:change', {
            detail: {
              writerOption: enable ? this.optionsData[1] : this.optionsData[0],
            },
          })
        );
      }
    }

    initStateFromParent(props) {
      const isEnabled = Object.keys(props)
        .map((key) => {
          const matchedInput = this.inputs.find((input) => input.name === key);
          if (matchedInput) {
            matchedInput.value = props[key];
            return true;
          }
          return false;
        })
        .includes(true);
      if (isEnabled && !this.isExtraFieldsActive) this.toggleExtraFields(true, false);
    }

    getOption() {
      // Parent module in "iWill" mode and Writers option available for this book -> 1 writer
      if (this.isDisabled) return this.optionsData[0];

      // Parent module in "someoneWill" mode and Writers option available for this book -> 1 writer / 2 writers
      return this.isExtraFieldsActive ? this.optionsData[1] : this.optionsData[0];
    }
  }
  customElements.define('up-perso-extra-writer', upPersoExtraWriter);
}

if (!customElements.get('up-perso-whom')) {
  class upPersoWhom extends HTMLElement {
    constructor() {
      super();
      this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.currentInput = this.inputs.find((input) => input.checked);
    }

    connectedCallback() {
      this.inputs.forEach((input) => {
        input.addEventListener('click', (event) => {
          this.currentInput = event.target;
          this.sendEventToParent();
        });
      });
    }

    initStateFromParent(whom) {
      this.currentInput = this.inputs.find((input) => input.value === whom);
      this.currentInput.checked = true;
      if (this.currentInput.checked && !this.currentInput.getAttribute('checked')) this.sendEventToParent();
    }

    sendEventToParent() {
      this.dispatchEvent(
        new CustomEvent('up:change', {
          detail: {
            whom: this.currentInput.value,
          },
        })
      );
    }

    verifyValidity() {
      let errorMessage = '';
      let validity = true;

      // Check if one radio input is checked
      if (!this.inputs[0].reportValidity()) {
        validity = false;
        errorMessage = window.upFormStrings.errorValidationType;
        this.inputs[0].classList.add('up-invalid-input');
      }

      return {
        validity: validity,
        errorMessage: errorMessage,
      };
    }

    getData() {
      const props = { _Whom: this.currentInput.value };
      props[this.currentInput.getAttribute('aria-label')] = this.currentInput.getAttribute('aria-details');
      return props;
    }
  }
  customElements.define('up-perso-whom', upPersoWhom);
}

if (!customElements.get('up-perso-addon')) {
  class upPersoAddon extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;
      this.variantPrice = parseInt(this.dataset.variantPrice || 0);
      this.checkBox = this.querySelector('input[type="checkbox"]');
    }

    connectedCallback() {
      this.checkBox.addEventListener('click', (event) => {
        this.dispatchEvent(
          new CustomEvent('up:change', {
            detail: {
              addonPrice: this.getVariantPrice(),
            },
          })
        );
      });
    }

    initStateFromParent(checked) {
      if (checked) this.checkBox.checked = true;
    }

    verifyValidity() {
      return {
        validity: true,
        errorMessage: '',
      };
    }

    getVariantId() {
      return this.checkBox.checked ? this.variantId : null;
    }

    getVariantPrice() {
      return this.checkBox.checked
        ? parseFloat(window.igData?.price?.getPriceByVariantId(this.variantId)) * 100 || this.variantPrice
        : 0;
    }
  }
  customElements.define('up-perso-addon', upPersoAddon);
}

if (!customElements.get('up-perso-copies-select')) {
  class upPersoVariantSelect extends HTMLElement {
    constructor() {
      super();
      this.bookCopySelect = this.querySelector('#Select-Quantity');
    }

    connectedCallback() {
      this.bookCopySelect.addEventListener('change', (event) => {
        this.dispatchEvent(
          new CustomEvent('up:change', {
            detail: {
              option: event.target.value,
            },
          })
        );
      });

      const testVariantPrice = window.igData?.price?.getPriceByVariantId(
        this.bookCopySelect.getAttribute('data-first-variant-id')
      );
      if (testVariantPrice) {
        this.updatePriceInText();
      } else {
        // Intelligems loaded after this module : maybe an experiment
        window.addEventListener('ig:ready', (event) => {
          this.updatePriceInText();
        });
      }
    }

    initStateFromParent(optionValue) {
      this.bookCopySelect.value = optionValue;
    }

    verifyValidity() {
      return {
        validity: true,
        errorMessage: '',
      };
    }

    getOption() {
      return this.bookCopySelect.value;
    }

    updatePriceInText() {
      const firstVariantPrice = window.igData?.price?.getPriceByVariantId(
        this.bookCopySelect.getAttribute('data-first-variant-id')
      );
      const nextVariantPrice = window.igData?.price?.getPriceByVariantId(
        this.bookCopySelect.getAttribute('data-next-variant-id')
      );

      if (!firstVariantPrice || !nextVariantPrice) return;
      const extraCopyPrice =
        parseInt(parseFloat(nextVariantPrice) * 100 || 0) - parseInt(parseFloat(firstVariantPrice) * 100 || 0);
      if (!extraCopyPrice) return;
      console.log(extraCopyPrice);

      // Update Price
      this.querySelector('#uP-Extra-Copy').textContent = upFormatMoney(extraCopyPrice);
      Array.from(this.bookCopySelect.options).forEach((option, index) => {
        option.textContent = option.textContent.replace(/\(\+.*\)/, `(+${upFormatMoney(extraCopyPrice * index)})`);
      });
    }
  }
  customElements.define('up-perso-copies-select', upPersoVariantSelect);
}

if (!customElements.get('up-perso-module')) {
  class upPersoModule extends HTMLElement {
    constructor() {
      super();

      this.bookHandle = this.dataset.bookHandle;
      this.cartBundleId = new URL(window.location.href).searchParams.get('up_bundle_id');

      this.urlParams = {
        whom: new URL(window.location.href).searchParams.get('whom'),
        directCheckout: new URL(window.location.href).searchParams.has('direct_checkout'),
      };

      // UI
      this.continueButton = this.querySelector('#BookForm-Continue-Button');
      this.stepViews = this.querySelectorAll('.up-bperso__step');
      this.stepsNavigation = this.querySelector('up-perso-steps');

      // Submodules
      this.whomModule = this.querySelector('up-perso-whom');
      this.copiesModule = this.querySelector('up-perso-copies-select');
      this.addonAudioModule = this.querySelector('up-perso-addon[addon-type="audio"]');
      this.addonWritingModule = this.querySelector('up-perso-addon[addon-type="writing"]');
      this.extraWriterModule = this.querySelector('up-perso-extra-writer');
      this.fieldsetModules = this.querySelectorAll('up-perso-fieldset');

      this.summaryModule = this.querySelector('up-perso-summary');

      // Data
      this.defaultProps = { _up_form_main: true, _up_form_id: Date.now(), _up_bundle_version: 1.0 };
      this.currentWhom = null;
    }

    connectedCallback() {
      Promise.all([customElements.whenDefined('up-perso-steps')]).then(() => {
        this.initStrings();
        if (this.cartBundleId) this.initDataFromCart();

        this.summaryModule.updateComponent({
          copiesOption: this.copiesModule.getOption(),
          writerOption: this.extraWriterModule?.getOption() || null,
          addonAudioPrice: this.addonAudioModule?.getVariantPrice() || 0,
          addonWritingPrice: this.addonWritingModule?.getVariantPrice() || 0,
        });

        this.initView();

        // Book specific
        if (this.bookHandle === 'book-im-writing-a-book-about-you')
          this.whomModule.querySelector('#uP-radio-iWill').click();

        // Extra URL parameters
        if (this.urlParams.directCheckout) {
          this.stepsNavigation.toggleStepVisibility(this.stepsNavigation.steps.length - 2, false);
          this.stepsNavigation.fakeReIndex();
        }
        if (this.urlParams.whom) {
          if (this.urlParams.whom === 'iWill') {
            this.whomModule.querySelector('#uP-radio-iWill').click();
            this.continueButton.click();
          }
          if (this.urlParams.whom === 'someoneWill') {
            this.whomModule.querySelector('#uP-radio-someoneWill').click();
            this.whomModule.classList.add('hidden');
          }
        }
      });

      this.continueButton.addEventListener('click', this.onContinueButtonClick.bind(this));

      // Regenerate for id when come from 'back to previous page' btn
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          console.log('Regenerate the form id');
          this.defaultProps._up_form_id = Date.now();
        }
      });

      // Events from child components
      this.stepsNavigation.addEventListener('up:change', (event) => {
        if (event.detail.index < this.currentViewIndex && event.detail.index < this.stepViews.length) {
          this.currentViewIndex = event.detail.index;
          this.updateViewUI();
        }
      });

      if (this.whomModule) {
        this.whomModule.addEventListener('up:change', (event) => {
          this.currentWhom = event.detail.whom;

          // Submodules
          this.querySelectorAll('.up-bperso__block[aria-owns="up-perso-whom"]').forEach((submodule) => {
            submodule.isDisabled = this.currentWhom === 'iWill';
            this.currentWhom === 'iWill' ? submodule.classList.add('hidden') : submodule.classList.remove('hidden');
          });

          // Views
          this.stepViews.forEach((stepView, index) => {
            if (stepView.getAttribute('aria-owns') === 'up-perso-whom') {
              if (this.currentWhom === 'iWill') {
                stepView.setAttribute('disabled', '');
                this.stepsNavigation.toggleStepVisibility(index, false);
              } else {
                stepView.removeAttribute('disabled');
                this.stepsNavigation.toggleStepVisibility(index, true);
              }
            }
          });
          this.stepsNavigation.fakeReIndex();

          // Summary state update
          if (this.extraWriterModule) {
            this.summaryModule.updateComponent({
              writerOption: this.extraWriterModule.getOption(),
            });
          }
        });
      }

      if (this.copiesModule) {
        this.copiesModule.addEventListener('up:change', (event) => {
          this.summaryModule.updateComponent({
            copiesOption: event.detail.option,
          });
        });
      }

      if (this.addonAudioModule) {
        this.addonAudioModule.addEventListener('up:change', (event) => {
          this.summaryModule.updateComponent({
            addonAudioPrice: event.detail.addonPrice,
          });
        });
      }

      if (this.addonWritingModule) {
        this.addonWritingModule.addEventListener('up:change', (event) => {
          this.summaryModule.updateComponent({
            addonWritingPrice: event.detail.addonPrice,
          });
        });
      }

      if (this.extraWriterModule) {
        this.extraWriterModule.addEventListener('up:change', (event) => {
          this.summaryModule.updateComponent({
            writerOption: event.detail.writerOption,
          });
        });
      }

      // Intelligems : Re-init the component when loaded after this module
      window.addEventListener('ig:ready', (event) => {
        this.summaryModule.updateComponent({
          copiesOption: this.copiesModule.getOption(),
          writerOption: this.extraWriterModule?.getOption() || null,
          addonAudioPrice: this.addonAudioModule?.getVariantPrice() || 0,
          addonWritingPrice: this.addonWritingModule?.getVariantPrice() || 0,
        });
      });
    }

    initView() {
      this.currentViewIndex = Array.from(this.stepViews).findIndex(
        (modulePerso) => modulePerso.getAttribute('aria-current') === 'false'
      );

      this.updateViewUI();
    }

    initStrings() {
      // Get the JS strings and set to window scope (Trick to decode HTML entities)
      var tempNode = document.createElement('textarea');
      tempNode.innerHTML =
        this.querySelector('[type="application/json"][aria-label="Form-Strings"]')?.textContent || '{}';
      window.upFormStrings = JSON.parse(tempNode.textContent);
    }

    initDataFromCart() {
      // Get main cart item props
      const cartData = JSON.parse(
        this.querySelector('[type="application/json"][aria-label="Cart-Data"]')?.textContent || '[]'
      );
      this.bundleItems = cartData.filter(
        (item) => (item.properties?._up_form_id || '').toString() === this.cartBundleId
      );

      // console.log(this.bundleItems);

      const mainItem = this.bundleItems.find((item) => item.properties?._up_form_main === true);
      if (!mainItem) return;
      const cartProps = mainItem.properties;

      // Init submodules
      this.whomModule.initStateFromParent(cartProps._Whom);

      this.fieldsetModules.forEach((fieldsetModule) => fieldsetModule.initStateFromParent(cartProps));

      const copyOptionLabels = window.upFormStrings.optionCopiesList.split(',');
      const copyOptionValue = mainItem.options_with_values.find((option) =>
        copyOptionLabels.includes(option.name.toLowerCase())
      )?.value;
      if (copyOptionValue && this.copiesModule) this.copiesModule.initStateFromParent(copyOptionValue);

      const copyWritersLabels = window.upFormStrings.optionWritersList.split(',');
      const isWriterOption = mainItem.options_with_values.find((option) =>
        copyWritersLabels.includes(option.name.toLowerCase())
      );
      if (isWriterOption && this.extraWriterModule) this.extraWriterModule.initStateFromParent(cartProps);

      // If has addons
      if (this.bundleItems.length > 1) {
        if (this.addonAudioModule && this.bundleItems.some((item) => item.id == this.addonAudioModule?.variantId)){
          this.addonAudioModule.initStateFromParent(true);
        }
        if (this.addonWritingModule && this.bundleItems.some((item) => item.id == this.addonWritingModule?.variantId)){
          this.addonWritingModule.initStateFromParent(true);
        }
      }
    }

    updateViewUI() {
      this.stepViews.forEach((stepView, index) => {
        stepView.setAttribute('aria-current', `${this.currentViewIndex === index ? 'true' : 'false'}`);
        this.currentViewIndex === index ? stepView.classList.remove('hidden') : stepView.classList.add('hidden');

        // update the child module step bar
        this.stepsNavigation.updateUI(index, index < this.currentViewIndex, index === this.currentViewIndex);
      });

      if (window.matchMedia('(max-width: 989px)').matches) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      if (this.urlParams.directCheckout) {
        this.continueButton.firstElementChild.textContent = Array.from(this.stepViews).find(
          (v, i) => i > this.currentViewIndex && !v.hasAttribute('disabled')
        )
          ? window.upFormStrings.buttonContinue.toUpperCase()
          : window.upFormStrings.buttonDirectCheckout.toUpperCase();
      }

      // Send to datalayer
      this.gtmViewUpdate();
    }

    gtmViewUpdate() {
      window.dataLayer = window.dataLayer || [];
      const indexViewToName = ['perso_personalize', 'perso_order_details', 'perso_gift_details'];
      dataLayer.push({
        event:
          this.currentViewIndex < indexViewToName.length ? indexViewToName[this.currentViewIndex] : 'perso_unknown',
        ecommerce: {
          items: {
            index: 0,
            item_id: `shopify_${Shopify.country}_${this.dataset.productId}_${this.summaryModule.getcurrentVariantId()}`,
            product_id: this.dataset.productId,
            variant_id: (this.summaryModule.getcurrentVariantId() || this.dataset.variantId).toString(),
          },
        },
      });
    }

    onContinueButtonClick() {
      const { validity, errorMessage } = this.verifyFormsInView();
      if (validity) {
        if (this.currentViewIndex >= this.stepViews.length - 1) {
          this.addToCart(this.parseData());
        } else if (this.stepViews[this.currentViewIndex + 1].hasAttribute('disabled')) {
          this.currentViewIndex = this.currentViewIndex + 1;
          this.onContinueButtonClick();
        } else {
          this.currentViewIndex = this.currentViewIndex + 1;
          this.updateViewUI();
        }
      } else {
        console.log(`validation failed -> ${errorMessage}`);
        // TODO: Scroll to the first invalid fields
      }
    }

    verifyFormsInView() {
      let globalErrorMessage = '';

      this.submodulesInView = Array.from(this.stepViews[this.currentViewIndex].querySelectorAll('.up-bperso__block'));
      const globalValidity = this.submodulesInView.every((submodule) => {
        if (submodule.isDisabled) return true;
        const { validity, errorMessage } = submodule.verifyValidity();
        globalErrorMessage = errorMessage;
        return validity;
      });
      return {
        validity: globalValidity,
        errorMessage: globalErrorMessage,
      };
    }

    parseData() {
      // Add extra props for Whom fields
      this.props = { ...this.defaultProps, ...this.whomModule.getData() };

      // Grab other props
      [...(this.extraWriterModule ? [this.extraWriterModule] : []), ...this.fieldsetModules].forEach(
        (fieldsetModule) => {
          if (!fieldsetModule.isDisabled) {
            this.props = { ...this.props, ...fieldsetModule.getData() };
          }
        }
      );

      // Create cart payload
      const items = [
        {
          id: this.summaryModule.getcurrentVariantId(),
          quantity: 1,
          properties: this.props,
        },
      ];

      // Add Writing Addon in payload if checked
      if (this.addonWritingModule?.getVariantId()) {
        const props = { _up_form_id: this.props._up_form_id, _up_bundle_version: 1.0 };
        props[window.upFormStrings.for] =
          this.props['_Whom'] === 'iWill'
            ? window.upFormStrings.mySubscription
            : window.upFormStrings.someoneSubscription.replace('[name]', this.props['_FirstRecipientFirstName']);

        items.push({
          id: this.addonWritingModule?.getVariantId(),
          quantity: 1,
          properties: props,
        });
      }

      // Add Audio Addon in payload if checked
      if (this.addonAudioModule?.getVariantId()) {
        const props = { _up_form_id: this.props._up_form_id, _up_bundle_version: 1.0 };
        props[window.upFormStrings.for] =
          this.props['_Whom'] === 'iWill'
            ? window.upFormStrings.mySubscription
            : window.upFormStrings.someoneSubscription.replace('[name]', this.props['_FirstRecipientFirstName']);

        items.push({
          id: this.addonAudioModule?.getVariantId(),
          quantity: 1,
          properties: props,
        });
      }
      return items;
    }

    async addToCart(items) {
      // Debouncing
      if (this.continueButton.getAttribute('aria-disabled') === 'true') return;
      this.continueButton.setAttribute('aria-disabled', true);

      // Add global attributes
      const cartAttributes = {
        _up_timezone: window.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
        _up_customer_locale:
          window.Shopify?.locale && window.Shopify?.country
            ? `${window.Shopify.locale}-${window.Shopify.country}`
            : navigator.language || navigator.userLanguage,
      };

      const body = JSON.stringify({
        items: items,
        attributes: cartAttributes,
      });

      this.continueButton.classList.add('loading');
      this.continueButton.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.cartBundleId) await this.clearOldBundle();

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((response) => {
          // There is an error
          if (response.status) {
            console.log(response);
          } else {
            window.location = this.urlParams.directCheckout ? '/checkout' : window.routes.cart_url;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.continueButton.removeAttribute('aria-disabled');
          this.continueButton.classList.remove('loading');
          this.continueButton.querySelector('.loading__spinner').classList.add('hidden');
        });
    }

    async clearOldBundle() {
      const itemsToRemove = {};
      this.bundleItems.forEach((item) => {
        itemsToRemove[item.key] = 0;
      });

      const body = JSON.stringify({
        updates: itemsToRemove,
      });
      // console.log(body);

      await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }
  }
  customElements.define('up-perso-module', upPersoModule);
}

if (!customElements.get('up-perso-summary')) {
  class upPersoSummary extends HTMLElement {
    constructor() {
      super();

      // UI
      this.uiCopiesQty = this.querySelector('.up-bperso__summary-prod-qty');
      this.uiAddonAudioAdded = this.querySelector('.up-bperso__summary-prod-addon-audio');
      this.uiAddonWritingAdded = this.querySelector('.up-bperso__summary-prod-addon-writing');
      this.uiProductPrice = this.querySelector('.up-bperso__summary-prod-price');
      this.uiProductPriceDiscounted = this.querySelector('.up-bperso__summary-prod-price-sale');
      this.uiSubtotalPrice = this.querySelector('.up-bperso__summary-totals-price');
      this.uiSubtotalPriceDiscounted = this.querySelector('.up-bperso__summary-totals-price-sale');
      this.uiDiscountBadge = this.querySelector('.up-bperso__summary-totals-prices .badge');

      // Accordion
      this.accordion = this.querySelector('.up-bperso__summary-prod-accordion');
      this.uiProductBullets = this.querySelector('.up-bperso__summary-prod-body');

      // Data
      this.state = {
        inputs: {
          copiesOption: null,
          writerOption: null,
          addonAudioPrice: 0,
          addonWritingPrice: 0,
        },
        outputs: {
          variantId: null,
          variantPrice: null,
          variantPriceDiscounted: null,
          subtotal: null,
          subtotalDiscounted: null,
        },
      };

      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      // console.log(this.variantData);
    }

    connectedCallback() {
      if (this.accordion && this.uiProductBullets) {
        this.accordion.addEventListener('click', (event) => {
          this.accordion.toggleAttribute('open');
          this.uiProductBullets.setAttribute('aria-expanded', this.accordion.hasAttribute('open'));
        });
      }
    }

    updateComponent(newInputState) {
      this.state.inputs = { ...this.state.inputs, ...newInputState };
      this.updateOutputState();
      // console.log(this.state);
      this.updateUI();
    }

    updateOutputState() {
      // Get the right option name
      const currentOptionsNames = [];
      if (this.state.inputs.writerOption) {
        currentOptionsNames.push(this.state.inputs.writerOption);
      }
      currentOptionsNames.push(this.state.inputs.copiesOption);

      // Get the current Variant
      // TODO: Faire une variante agnostique à l'ordre des options1,2,3
      // TODO: Regarder si les 2 arrays ont les même clés, après avoir ordonnées les 2 tableaux par exemple ?
      const currentVariant = this.variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return currentOptionsNames[index] === option;
          })
          .includes(false);
      });

      // Update the output state
      if (currentVariant) {
        this.state.outputs.variantId = currentVariant.id;
        this.state.outputs.variantPrice =
          parseFloat(window.igData?.price?.getPriceByVariantId(currentVariant.id)) * 100 || currentVariant.price;
        this.state.outputs.variantPriceDiscounted =
          this.state.outputs.variantPrice * (1 - parseInt(this.dataset.visualDiscount || '0') / 100);
      }

      this.state.outputs.subtotal =
        this.state.outputs.variantPrice + this.state.inputs.addonAudioPrice + +this.state.inputs.addonWritingPrice;
      this.state.outputs.subtotalDiscounted =
        this.state.outputs.variantPriceDiscounted +
        (this.state.inputs.addonAudioPrice + this.state.inputs.addonWritingPrice) *
          (1 - parseInt(this.dataset.visualDiscount || '0') / 100);
    }

    updateUI() {
      this.uiCopiesQty.textContent = this.state.inputs.copiesOption;
      this.uiProductPrice.textContent = upFormatMoney(this.state.outputs.variantPrice);
      this.uiProductPrice.setAttribute('data-variant-id', this.state.outputs.variantId); // For Intelligems

      if (
        this.uiProductPriceDiscounted &&
        this.state.outputs.variantPriceDiscounted !== this.state.outputs.variantPrice
      ) {
        this.uiProductPriceDiscounted.textContent = upFormatMoney(this.state.outputs.variantPriceDiscounted);
      }

      this.uiSubtotalPrice.textContent = upFormatMoney(this.state.outputs.subtotal);
      if (this.uiSubtotalPriceDiscounted && this.state.outputs.subtotalDiscounted !== this.state.outputs.subtotal) {
        this.uiSubtotalPriceDiscounted.textContent = upFormatMoney(this.state.outputs.subtotalDiscounted);
      }

      if (this.uiDiscountBadge && this.state.outputs.subtotalDiscounted !== this.state.outputs.subtotal) {
        this.uiDiscountBadge.textContent = `${this.dataset.visualDiscount}% OFF | -${upFormatMoney(
          this.state.outputs.subtotal - this.state.outputs.subtotalDiscounted
        )}`;
      }

      this.uiAddonAudioAdded.textContent =
        this.state.inputs.addonAudioPrice > 0 ? window.upFormStrings.audiobookAddedSummary : '';

      this.uiAddonWritingAdded.textContent =
        this.state.inputs.addonWritingPrice > 0 ? window.upFormStrings.writingSessionAddedSummary : '';
    }

    getcurrentVariantId() {
      return this.state.outputs.variantId;
    }
  }
  customElements.define('up-perso-summary', upPersoSummary);
}
